<template>
    <div class="card dashboard-card h-100">
        <div class="card-body">
            <span class="eyebrow">Retail status</span>
            <h4 class="card-title">Outcome mix</h4>

            <div class="kpi-strip">
                <div class="kpi-item">
                    <span>Sold</span>
                    <strong>{{ counts.sold }}</strong>
                </div>
                <div class="kpi-item">
                    <span>Closing</span>
                    <strong>{{ counts.closing }}</strong>
                </div>
                <div class="kpi-item danger">
                    <span>Rejected</span>
                    <strong>{{ counts.rejected }}</strong>
                </div>
            </div>

            <GChart
                :settings="{ packages: ['corechart'] }"
                type="PieChart"
                :data="chartData"
                :options="chartOptions"
                :resizeDebounce="500"
            ></GChart>
        </div>
    </div>
</template>
<script>
import { GChart } from "vue-google-charts";

export default {
    name: "SummaryOutcomesCard",
    components: {
        GChart,
    },
    props: {
        counts: {
            type: Object,
            required: true,
        },
    },
    computed: {
        chartData() {
            return [
                ["Status", "Count"],
                ["Sold", this.counts.sold],
                ["Closing", this.counts.closing],
                ["Rejected", this.counts.rejected],
                ["Estimate", this.counts.estimate],
            ];
        },
        chartOptions() {
            return {
                pieHole: 0.68,
                pieSliceText: "value",
                height: 260,
                backgroundColor: "transparent",
                colors: ["#18a85a", "#f39c12", "#e74c3c", "#4f6d8c"],
                chartArea: { left: 20, top: 20, width: "90%", height: 200 },
                legend: { position: "bottom", textStyle: { color: "#4c5968", fontSize: 12 } },
            };
        },
    },
};
</script>
<style scoped>
.dashboard-card {
    border: 1px solid #dbe4ea;
    border-radius: 16px;
    box-shadow: 0 12px 30px rgba(31, 60, 90, 0.08);
    min-height: 450px;
    margin-bottom: 20px;
}

.dashboard-card .card-body {
    background-color: #ffffff;
}
.eyebrow {
    display: block;
    color: #6f7d8a;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.card-title {
    margin: 4px 0 16px;
    color: #24313f;
    font-size: 24px;
    font-weight: 700;
}

.kpi-strip {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 12px;
    margin-bottom: 6px;
}

.kpi-item {
    padding: 12px;
    border-radius: 12px;
    background: #f4f8fb;
    color: #344453;
}

.kpi-item span {
    display: block;
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    opacity: 0.8;
}

.kpi-item strong {
    font-size: 24px;
    line-height: 1;
}

.kpi-item.danger {
    background: #fff1f0;
    color: #bb3d30;
}
</style>